import { baseApi } from './baseApi'

export const usersApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getUsers: builder.query({
            query: (params) => ({
                url: '/users',
                params
            }),
            providesTags: (result) =>
                result?.items
                    ? [
                          ...result.items.map((u) => ({ type: 'Users', id: u.tid })),
                          { type: 'Users', id: 'LIST' }
                      ]
                    : [{ type: 'Users', id: 'LIST' }]
        }),
        getUser: builder.query({
            query: (userId) => ({ url: `/users/${userId}` }),
            providesTags: (_r, _e, userId) => [{ type: 'Users', id: userId }]
        }),
        createUser: builder.mutation({
            query: (body) => ({
                url: '/users',
                method: 'POST',
                body
            }),
            invalidatesTags: [{ type: 'Users', id: 'LIST' }]
        }),
        updateUser: builder.mutation({
            query: ({ userId, body }) => ({
                url: `/users/${userId}`,
                method: 'PUT',
                body
            }),
            invalidatesTags: (_r, _e, { userId }) => [
                { type: 'Users', id: 'LIST' },
                { type: 'Users', id: userId }
            ]
        }),
        deleteUsers: builder.mutation({
            query: (userIds) => ({
                url: `/users/${Array.isArray(userIds) ? userIds.join(',') : userIds}`,
                method: 'DELETE'
            }),
            invalidatesTags: [{ type: 'Users', id: 'LIST' }]
        }),
        checkUserExists: builder.mutation({
            query: (body) => ({
                url: '/users/exists',
                method: 'POST',
                body
            })
        }),
        uploadAvatar: builder.mutation({
            query: ({ userId, file }) => {
                const formData = new FormData()
                formData.append('avatar', file)
                return {
                    url: `/users/${userId}/avatar`,
                    method: 'POST',
                    body: formData
                }
            },
            invalidatesTags: (_r, _e, { userId }) => [
                { type: 'Users', id: userId },
                { type: 'Users', id: `${userId}-avatar` }
            ]
        }),
        deleteAvatar: builder.mutation({
            query: (userId) => ({
                url: `/users/${userId}/avatar`,
                method: 'DELETE'
            }),
            invalidatesTags: (_r, _e, userId) => [
                { type: 'Users', id: userId },
                { type: 'Users', id: `${userId}-avatar` }
            ]
        }),
        updateUserSettings: builder.mutation({
            query: ({ userId, settings }) => ({
                url: `/users/${userId}/settings`,
                method: 'PUT',
                body: { settings }
            })
        })
    })
})

export const {
    useGetUsersQuery,
    useGetUserQuery,
    useCreateUserMutation,
    useUpdateUserMutation,
    useDeleteUsersMutation,
    useCheckUserExistsMutation,
    useUploadAvatarMutation,
    useDeleteAvatarMutation,
    useUpdateUserSettingsMutation
} = usersApi
